// File: /src/components/common/ConfirmDialog.js

import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from '@mui/material';
import { Warning, Info, Error as ErrorIcon } from '@mui/icons-material';

const variantConfig = {
	danger: {
		icon: ErrorIcon,
		color: '#dc3545',
		confirmColor: 'error',
		title: 'Confirmar Exclusão',
	},
	warning: {
		icon: Warning,
		color: '#f59e0b',
		confirmColor: 'warning',
		title: 'Atenção',
	},
	info: {
		icon: Info,
		color: '#3b82f6',
		confirmColor: 'primary',
		title: 'Confirmação',
	},
};

function ConfirmDialog({
	open,
	title,
	message,
	onConfirm,
	onCancel,
	confirmText = 'Confirmar',
	cancelText = 'Cancelar',
	variant = 'danger',
}) {
	const config = variantConfig[variant] || variantConfig.danger;
	const IconComponent = config.icon;

	const handleConfirm = () => {
		onConfirm();
	};

	const handleCancel = () => {
		onCancel();
	};

	return (
		<Dialog
			open={open}
			onClose={handleCancel}
			aria-labelledby="confirm-dialog-title"
			aria-describedby="confirm-dialog-description"
			PaperProps={{
				sx: {
					borderRadius: '12px',
					padding: '8px',
					maxWidth: '450px',
				},
			}}
		>
			<DialogTitle
				id="confirm-dialog-title"
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1.5,
					paddingBottom: 1,
					fontFamily: "'Plus Jakarta Sans', sans-serif",
					fontWeight: 700,
					fontSize: '1.25rem',
				}}
			>
				<IconComponent sx={{ color: config.color, fontSize: '28px' }} />
				{title || config.title}
			</DialogTitle>
			<DialogContent>
				<DialogContentText
					id="confirm-dialog-description"
					sx={{
						fontFamily: "'Plus Jakarta Sans', sans-serif",
						fontSize: '1rem',
						color: 'text.primary',
						paddingTop: 1,
					}}
				>
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
				<Button
					onClick={handleCancel}
					variant="outlined"
					sx={{
						fontFamily: "'Plus Jakarta Sans', sans-serif",
						fontWeight: 600,
						textTransform: 'none',
						borderRadius: '8px',
						padding: '8px 20px',
					}}
				>
					{cancelText}
				</Button>
				<Button
					onClick={handleConfirm}
					variant="contained"
					color={config.confirmColor}
					autoFocus
					sx={{
						fontFamily: "'Plus Jakarta Sans', sans-serif",
						fontWeight: 600,
						textTransform: 'none',
						borderRadius: '8px',
						padding: '8px 20px',
					}}
				>
					{confirmText}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ConfirmDialog;
